import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import NotFound from './components/404';
import GameTab from './components/astrapos/GameTab';
import Login from './components/auth/Login';
import BlockTableComponent from './components/BlockTableComponent';
import CreateTransactionPage from './components/CreateTransactionPage';
import Dashboard from './components/Dashboard';
import EtherScanComponent from './components/EtherScanComponent';
import Home from './components/Home';
import DashboardLayout from './components/layout/DashboardLayout';
import Leaderboard from './components/leaderboard';
import MempoolComponent from './components/MempoolComponent';
import MyTransactionComponent from './components/MyTransactionComponent';
import Participants from './components/Participants';
import Room from './components/Room';
import TransactionComponent from './components/TransactionComponent';
import { useGameStateSync } from './utils/useGameStateSync';
import ProtectedRoute from './components/utils/ProtectedRoute';

function App() {
  useGameStateSync();
  return (
    <>
      <Toaster />
      <main className="main-content">
        <Routes>
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Home />} />
          <Route path="/joinedroom" element={<Room />} />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <CreateTransactionPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/blocks" element={<BlockTableComponent />} />
          <Route path="/transaction" element={<TransactionComponent />} />
          <Route
            path="/my-transactions"
            element={
              <ProtectedRoute>
                <MyTransactionComponent />
              </ProtectedRoute>
            }
          />
          <Route path="/explore" element={<EtherScanComponent />} />
          <Route path="/mempool" element={<MempoolComponent />} />
          <Route
            path="/leaderboard"
            element={
              <ProtectedRoute>
                <Leaderboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lobby"
            element={
              <ProtectedRoute>
                <Participants />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <GameTab />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </>
  );
}

export default App;
